import { FaBars } from 'react-icons/fa'
import { useState, useEffect } from 'react'
import { animateScroll as scroll } from 'react-scroll';
import { HeroSpan } from '../Hero/HeroElems'
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks 
} from './NavbarElems'
import { IconContext } from 'react-icons/lib';

export default function Navbar({toggle}) {
  const [scrollNav, setScrollNav] = useState(false)
  const changeNav = () => {
    if(window.scrollY >= 80) {
      setScrollNav(true)
    } else {
      setScrollNav(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', changeNav)
  }, [])

  const toggleHome = () => {
    scroll.scrollToTop();
  }
  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
      <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to='/' onClick={toggleHome}><span>&#123;</span>tyler<HeroSpan>Gan</HeroSpan><span>&#125;</span></NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks to='about' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  About
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='hobbies' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Hobbies
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='education' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Education
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='experience' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Experience
                </NavLinks>
              </NavItem>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  )
}
